import { render, staticRenderFns } from "./wxJqr.vue?vue&type=template&id=2b52bf0e"
import script from "./wxJqr.vue?vue&type=script&lang=js"
export * from "./wxJqr.vue?vue&type=script&lang=js"
import style0 from "./wxJqr.vue?vue&type=style&index=0&id=2b52bf0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports